module.exports = __webpack_public_path__ + "static/media/43_A.67bede20.png";